import { render, staticRenderFns } from "./GoogleDriveDownloadFile.vue?vue&type=template&id=1b8f973a&scoped=true"
import script from "./GoogleDriveDownloadFile.vue?vue&type=script&lang=js"
export * from "./GoogleDriveDownloadFile.vue?vue&type=script&lang=js"
import style0 from "./GoogleDriveDownloadFile.vue?vue&type=style&index=0&id=1b8f973a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f973a",
  null
  
)

export default component.exports